export function getAuthoredContent<T>(scriptId: string): T {
	const authoringScript = document.getElementById(scriptId);
	if (authoringScript) {
		return JSON.parse(authoringScript.innerHTML);
	}
	return {} as T;
}
